<template>
  <div class="OutriggersHome">
    <b-card-group deck>
      <b-card
        title= "Event Acquisition Status"
        tag="article"
        class="mb-2"
        style="max-width: 50rem; background-color: black; color: white"
      >
        <b-card-text>
          <eventdataacq></eventdataacq>
        </b-card-text>
      </b-card>
      <b-card
        title= "Calibrator Observations"
        tag="article"
        class="mb-2"
        style="max-width: 50rem; background-color: black; color: white"
      >
        <b-card-text>
          <trackingbeam></trackingbeam>
        </b-card-text>
      </b-card>
    </b-card-group>
    <img src="https://frb.chimenet.ca/outrigger_coordination_processes.png" width='100%'>
  </div>
</template>
<script>
import eventDataAcq from './event_data_acq'
import trackingBeam from './tracking_beam'
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  components: {
    'eventdataacq': eventDataAcq,
    'trackingbeam': trackingBeam
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outriggers/outriggers_home.vue